import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RewardsResponse, CategoriesResponse } from '../models/request.model';
import { endpoints } from 'src/app/utils/endpoints';

@Injectable({ providedIn: 'root' })
export class RewardsService {

  constructor(private http: HttpClient) { }

  fetchRewards(profileId: string, categoryId?: string): Observable<RewardsResponse> {
    let params = new HttpParams()
    if (categoryId) params = params.set('categoryId', categoryId);
    return this.http.get<RewardsResponse>(
      endpoints.challenges.children.getChallenges(
        profileId
      ), { params }
    );
  }

  fetchCategories(): Observable<CategoriesResponse> {
    return this.http.get<CategoriesResponse>(
      endpoints.challenges.children.getCategories(
      ),
    );
  }

  fetchNotLogedUserRewards(categoryId: string): Observable<RewardsResponse> {
    let params = new HttpParams()
    if (categoryId) params = params.set('categoryId', categoryId);
    return this.http.get<RewardsResponse>(
      endpoints.challenges.children.getNonLogedRewards(
      ), { params },
    );
  }


  rewardsClaim(profileId: string, rewardIds: string[]): Observable<Object> {
    return this.http.post<Object>(
      endpoints.challenges.children.rewardsClaim(profileId), { rewardIds }
    );
  }

  fetchAllPerks() {
    return this.http.get<any>(endpoints.userProfile.children.getAllPerks());
  }
  fetchCurrentProfilePerks(currentProfileId: string){
      return this.http.post<Object>(
          endpoints.userProfile.children.getAllPerks(), { profileIds:[currentProfileId] }
      );
  }

  fetchProfilesPerks(profileIds: string[]) {
      return this.http.post<Object>(
        endpoints.userProfile.children.getAllPerks(), { profileIds }
      );
  }
}

